import { IComponentStyles } from '@fluentui/foundation-legacy';
import { IPanelStyles, IStackSlots, IStyle } from '@fluentui/react';
import { ICorptaxTheme } from '../ICorptaxTheme';
import { IPanelContainerStyles } from './IPanelContainerStyles';

export class CorptaxThemePanelContainerStyles implements IPanelContainerStyles {
    constructor(
        private theme: ICorptaxTheme,
        private width: number,
        private scrollbarStyles: IStyle
    ) {
        this.customWidth = `${width}px`;
    }

    customWidth: string;

    get panelNavigationStack(): IComponentStyles<IStackSlots> {
        return {
            root: {
                paddingRight: 10,
            },
        };
    }
    get panelStyles(): Partial<IPanelStyles> {
        return {
            commands: {
                backgroundColor: this.theme.palette.white,
            },
            scrollableContent: this.scrollbarStyles,
            content: {
                padding: 8,
            },
        };
    }
}
